/**
 * An insurance member ID as an eligibility check sends it: uppercase, with the
 * spaces and dashes a card prints removed. Null when what is left is not one.
 */
export const normalizeMemberId = (value: string): string | null => {
  const memberId = value.replace(/[\s-]/g, "").toUpperCase();
  return /^[A-Z0-9]{5,30}$/.test(memberId) ? memberId : null;
};
